import { IconButton } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BlockClicks } from "lib/@components/block-clicks"
import Iconify from "minimals-template/components/Iconify"
import { navigateAddTask } from "../utilities/project-navigation"
import { useParams } from "react-router"
import { NavigateTask } from "event-definitions"
import { GroupStatus } from "../../../lib/enum/group-status.mjs"

export function EditAddedTaskButton() {
    const { index, projectGroup } = useBoundContext()
    const { projectId, groupId } = useParams()
    return (
        <BlockClicks>
            <IconButton
                aria-label="Edit task"
                sx={{ color: "primary.main" }}
                data-cy="edit-new-task-button"
                onClick={() => navigateEditTask({ projectId, groupId, index })}
                disabled={projectGroup?.status === GroupStatus.APPLIED}
            >
                <Iconify icon="material-symbols:edit" />
            </IconButton>
        </BlockClicks>
    )
}

function navigateEditTask({ projectId, groupId, index }) {
    navigateAddTask({ projectId, groupId })
    NavigateTask.raiseOnceDelay(500, index)
}
